
export const GET_VEHICLE_TYPES_REQUESTED = 'brand/GET_VEHICLE_TYPES_REQUESTED';
export const GET_VEHICLE_TYPES_SUCCESS = 'brand/GET_VEHICLE_TYPES_SUCCESS';
export const GET_VEHICLE_TYPES_FAILURE = 'brand/GET_VEHICLE_TYPES_FAILURE';

export const GET_VEHICLE_COLORS_REQUESTED = 'brand/GET_VEHICLE_COLORS_REQUESTED';
export const GET_VEHICLE_COLORS_SUCCESS = 'brand/GET_VEHICLE_COLORS_SUCCESS';
export const GET_VEHICLE_COLORS_FAILURE = 'brand/GET_VEHICLE_COLORS_FAILURE';

export const GET_DRIVE_THRU_CONFIG_REQUESTED = 'brand/GET_DRIVE_THRU_CONFIG_REQUESTED';
export const GET_DRIVE_THRU_CONFIG_SUCCESS = 'brand/GET_DRIVE_THRU_CONFIG_SUCCESS';
export const GET_DRIVE_THRU_CONFIG_FAILURE = 'brand/GET_DRIVE_THRU_CONFIG_FAILURE';

export const UPDATE_DRIVE_THRU_CONFIG_REQUESTED = 'brand/UPDATE_DRIVE_THRU_CONFIG_REQUESTED';
export const UPDATE_DRIVE_THRU_CONFIG_SUCCESS = 'brand/UPDATE_DRIVE_THRU_CONFIG_SUCCESS';
export const UPDATE_DRIVE_THRU_CONFIG_FAILURE = 'brand/UPDATE_DRIVE_THRU_CONFIG_FAILURE';

export const GET_VEHICLE_LANES_REQUESTED = 'brand/GET_VEHICLE_LANES_REQUESTED';
export const GET_VEHICLE_LANES_SUCCESS = 'brand/GET_VEHICLE_LANES_SUCCESS';
export const GET_VEHICLE_LANES_FAILURE = 'brand/GET_VEHICLE_LANES_FAILURE';


const initialState = {
  loading: false,
  loaded: false,
  error: false,
  vehicleTypesList: [],
  vehicleColorsList: [],
  brandDriveThruConfigData: [],
  vehicleLanesList: []
};

export default(state = initialState, action) => {
  switch (action.type) {
    case GET_VEHICLE_TYPES_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        version: null,
      };
    }
    case GET_VEHICLE_TYPES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        vehicleTypesList: action.result,
      };
    }
    case GET_VEHICLE_TYPES_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case GET_VEHICLE_COLORS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_VEHICLE_COLORS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        vehicleColorsList: action.result,

      };
    }
    case GET_VEHICLE_COLORS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case GET_DRIVE_THRU_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_DRIVE_THRU_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        brandDriveThruConfigData: action.result,
      };
    }
    case GET_DRIVE_THRU_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
        brandDriveThruConfigData: []
      };
    }
    case UPDATE_DRIVE_THRU_CONFIG_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case UPDATE_DRIVE_THRU_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case UPDATE_DRIVE_THRU_CONFIG_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case GET_VEHICLE_LANES_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_VEHICLE_LANES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        vehicleLanesList: action.result,
      };
    }
    case GET_VEHICLE_LANES_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export const getVehicleTypes = () => {
  return {
    types: [GET_VEHICLE_TYPES_REQUESTED, GET_VEHICLE_TYPES_SUCCESS, GET_VEHICLE_TYPES_FAILURE],
    promise: client => client.get('getVehicleTypes')
  };
};

export const getVehicleColors = () => {
  return {
    types: [GET_VEHICLE_COLORS_REQUESTED, GET_VEHICLE_COLORS_SUCCESS, GET_VEHICLE_COLORS_FAILURE],
    promise: client => client.get('getVehicleColors')
  };
};

export const getBrandDriveThruConfig = (brandId) => {
  return {
    types: [GET_DRIVE_THRU_CONFIG_REQUESTED, GET_DRIVE_THRU_CONFIG_SUCCESS, GET_DRIVE_THRU_CONFIG_FAILURE],
    promise: client => client.get(`getBrandDriveThruConfig/${brandId}`)
  };
};

export const updateBrandDriveThruConfig = (data) => {
  return {
    types: [UPDATE_DRIVE_THRU_CONFIG_REQUESTED, UPDATE_DRIVE_THRU_CONFIG_SUCCESS, UPDATE_DRIVE_THRU_CONFIG_FAILURE],
    promise: client => client.post('updateBrandDriveThruConfig', { data })
  };
};

export const getVehicleLanes = () => {
  return {
    types: [GET_VEHICLE_LANES_REQUESTED, GET_VEHICLE_LANES_SUCCESS, GET_VEHICLE_LANES_FAILURE],
    promise: client => client.get('getVehicleLanes')
  };
};
